import useSWR from 'swr';

import { ENDPOINTS } from '@/api/endpoints';
import { getSuggestedICD10Codes } from '@/api/icd-codes';

export const useGetSuggestedICD10Codes = () => {
  const { data, isLoading, mutate } = useSWR(
    ENDPOINTS.ICD10_CODE_SUGGESTION,
    () => getSuggestedICD10Codes(),
    { revalidateOnFocus: false }
  );

  return {
    data: data?.all.map((icd) => `${icd.code} - ${icd.description}`),
    loading: isLoading,
    refetchCases: mutate,
  };
};
